import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tag } from 'primereact/tag';
import axios from 'axios'
import 'primeflex/primeflex.css';
import { API_Root } from "../globalState";
import { isChaseVehicle } from "./trip/vehicleName";

export const TripInfo = (props) => {
   const [trip, setTrip] = useState();
   const [tripId, setTripId] = useState();
   const [userId, setUserId] = useState();
   const [busyId, setBusyId] = useState();
   const [rejectedIds, setRejectedIds] = useState([]);

   const loadTrip = (tid, uid) => {
      if (!tid || !uid) {
         return;
      }
      var apiUrl = `${API_Root}api/trip/GetTrip?id=${tid}`;
      axios.get(apiUrl).then((values) => {
         if (values.data != null) {
            setTrip(values.data);
            setTripId(tid);
            setUserId(uid);
         }
      });
   };

   useEffect(() => {
      const query = new URLSearchParams(props.location.search);
      loadTrip(query.get('t'), query.get('u'));
   }, [props.location.search]);

   const confirmVehicle = (vehicleId) => {
      setBusyId(vehicleId);
      var apiUrl = `${API_Root}api/trip/ConfirmPorter?tripId=${tripId}&porterId=${userId}&vehicleId=${vehicleId}`;
      axios.get(apiUrl).then(() => {
         loadTrip(tripId, userId);
      }).finally(() => setBusyId(null));
   };

   const rejectVehicle = (vehicleId) => {
      setBusyId(vehicleId);
      var apiUrl = `${API_Root}api/trip/RejectPorter?tripId=${tripId}&porterId=${userId}&vehicleId=${vehicleId}`;
      axios.get(apiUrl).then(() => {
         setRejectedIds((ids) => ids.concat(vehicleId));
         loadTrip(tripId, userId);
      }).finally(() => setBusyId(null));
   };

   const formatDate = (dt) => {
      var d = new Date(dt);
      return d.toLocaleDateString('en-US', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
      });
   };

   const formatTime = (dt) => {
      var d = new Date(dt);
      return d.toLocaleTimeString('en-US', {
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
      });
   };

   const formatBool = (b) => {
      if (b) {
         return "Yes";
      } else {
         return "No";
      }
   };

   const porterListTemplate = (p) => {
      const mine = p.porterId == userId;
      const rejected = rejectedIds.includes(p.id);
      let type;
      if (rejected || (mine && !p.porterId)) {
         type = <Tag severity="danger" value="Rejected"></Tag>;
      }
      else if (!p.confirmed) {
         type = <Tag severity="warning" value="Unconfirmed"></Tag>;
      }
      else if (p.isChase) {
         type = <Tag severity="success" value="Chase"></Tag>;
      }
      else {
         type = <Tag severity="info" value="Driver"></Tag>;
      }

      return (
         <div key={p.id} className="w-full mt-4">
            <div>
               {isChaseVehicle(p)
                  ? <span className="font-bold">Chase</span>
                  : <><span className="font-bold">{p.vehicleVIN}</span> - {p.vehicleYear} {p.vehicleMake} {p.vehicleModel}</>}
            </div>
            <div className="flex flex-row flex-wrap align-items-center">
               {p.User && (
                  <>
                     <div className="mr-4">
                        {p.User.firstName} {p.User.lastName}
                     </div>
                     <div className="mr-4">
                        <a href={"tel:" + p.User.phone}>{p.User.phone}</a>
                     </div>
                  </>
               )}
               <div className="mr-4">
                  {type}
               </div>
            </div>
            {mine && !p.confirmed && !rejected ? (
               <div className="mt-2">
                  <Button className="mr-2" label="Reject" onClick={() => rejectVehicle(p.id)} disabled={busyId === p.id}></Button>
                  <Button label="Confirm" onClick={() => confirmVehicle(p.id)} loading={busyId === p.id} disabled={busyId === p.id}></Button>
               </div>
            ) : null}
            {mine && p.confirmed ? (
               <div className="mt-2 font-italic">This vehicle has been confirmed</div>
            ) : null}
         </div>
      );
   };

   if (trip) {

      return (<Card>
         <div className="grid">
            <div className="col-12">
               <h3>Trip for {trip.Dealership.dealershipName}</h3>
            </div>
         </div>
         <Divider />
         <div className="grid">
            <div className="col-12">
               <span className="font-bold">Depart: </span>{formatDate(trip.departDateTimeStart)} - {formatTime(trip.departDateTimeEnd)}
            </div>
            <div className="col-12">
               <span className="font-bold">Arrive: </span>{formatDate(trip.requestedDeliveryDateTime)} - {formatTime(trip.requestedDeliveryDateTimeEnd)}
               {trip.pickupDateTime ? (
                  <div className="mt-1">
                     <span className="font-bold">Pickup available: </span>{formatDate(trip.pickupDateTime)}
                  </div>
               ) : null}
            </div>
         </div>
         <div className="flex flex-wrap">
            <div className="mr-4 mb-2">
               <span className="font-bold">Number of Vehicles: </span>{trip.TripVehicles.length}
            </div>
            <div className="mr-4 mb-2">
               <span className="font-bold">Chase Car: </span>{formatBool(trip.roundTrip)}
            </div>
            <div className="">
            </div>
         </div>
         <Divider />
         <div className="grid">
            <div className="col-12 md:col-6 font-bold">
               Source
         </div>
            <div className="col-12 md:col-6 font-bold">
               Destination
         </div>
         </div>
         <div className="grid">
            <div className="col-12 md:col-6">
               <div className="w-full">{trip.Dealership2.dealershipName ?? "Private address"}</div>
               <div className="w-full">{trip.Dealership2.streetAddress}</div>
               <div className="w-full">{trip.Dealership2.city} {trip.Dealership2.stateAbbr} {trip.Dealership2.zipCode}</div>
            </div>
            <div className="col-12 md:col-6">
               <div className="w-full">{trip.Dealership1.dealershipName ?? "Private address"}</div>
               <div className="w-full">{trip.Dealership1.streetAddress}</div>
               <div className="w-full">{trip.Dealership1.city} {trip.Dealership1.stateAbbr} {trip.Dealership1.zipCode}</div>
            </div>
         </div>
         <Divider />
         {trip?.TripVehicles?.map((p) => {
            return porterListTemplate(p);
         })}
      </Card>);
   }
   else {
      return (<Card className="text-center"><ProgressSpinner /></Card>);
   }

}
